import config from 'config';

export const getMediaAssetURL = (mediaAssetID, sessionID) =>
  `${config.serverURL}/api/mediaassets/stream/${mediaAssetID}?sessionID=${sessionID}`;